import { FC } from 'react';
import ReserveList from './ReserveList';
import UseReserveList from './UseReserveList';

const ReserveListContainer: FC = () => {
  return <ReserveList {...UseReserveList()} />;
};

export default ReserveListContainer;
